module.exports = __webpack_public_path__ + "media/images/vp/icon.download.white-d831e16c82776436b35e2e3578919493.svg";